import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const DepartmentsPageSession = React.lazy(() => import('../departments/DepartmentsPageSession'));
const DepartmentsPageHeader = React.lazy(() => import('../departments/DepartmentsPageHeader'));

function DepartmentsPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <DepartmentsPageHeader />
       <DepartmentsPageSession />
      </Suspense>
    </div>
  );
}

export default DepartmentsPage;
